/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/QaTemplateCreateMenu.tsx
 * FILE_ID: JOBHUB-QA-TEMPLATE-PLUS-001
 * PURPOSE: Plus menu for a new library template or the archived structure cards.
 */
import { useEffect, useRef, useState } from 'react'
import { Plus } from 'lucide-react'
import { MobileSheet } from '@quotech/ui'

export function QaTemplateCreateMenu({
  phone,
  onNew,
  onArchived,
}: {
  phone: boolean
  onNew: () => void
  onArchived: () => void
}) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!open || phone) return
    const onDown = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false)
    }
    window.addEventListener('mousedown', onDown)
    return () => window.removeEventListener('mousedown', onDown)
  }, [open, phone])

  const choose = (action: () => void) => {
    setOpen(false)
    action()
  }
  const rows = (
    <>
      <button type="button" role="menuitem" className="flex min-h-[44px] w-full items-center px-3 text-left text-sm" onClick={() => choose(onNew)}>
        New template
      </button>
      <button type="button" role="menuitem" className="flex min-h-[44px] w-full items-center px-3 text-left text-sm" onClick={() => choose(onArchived)}>
        Archived templates
      </button>
    </>
  )
  return (
    <div ref={rootRef} className="relative">
      <button
        type="button"
        title="add new template"
        aria-label="add new template"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        className="rounded-md p-1 text-muted-foreground hover:text-foreground"
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
      </button>
      {phone ? (
        <MobileSheet open={open} onClose={() => setOpen(false)} title="Templates">
          <div role="menu">{rows}</div>
        </MobileSheet>
      ) : open ? (
        <div role="menu" className="absolute right-0 z-20 mt-1 w-48 rounded-md border border-border bg-card py-1 shadow-lg">
          {rows}
        </div>
      ) : null}
    </div>
  )
}
